import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { clientQuery } from "../../../../../core/data/GraphQLApi";
import { endpoints } from "../../../../../core/defaultValues";
import { ExceptionManager } from "../../../../../core/logManager";
import { resetALL } from "../../../../../.globals/redux/actions";

const INIT_STATE = {
  loading: false,
  items: [],
  total: 0,
  error: null,
};

const route = "modules/manage/views/main/components/assetSubtype/redux/slice.";

const manageSearchAssetSubtypes = createAsyncThunk(
  "manage/assetSubtype/manageSearchAssetSubtypes",
  async ({ conditions, sort, limit = 10, offset = 0 }, { rejectWithValue }) => {
    try {
      const response = await clientQuery(
        manageSearchAssetSubtypes.query,
        {
          conditions,
          sort,
          limit,
          offset,
        },
        endpoints.GRAPHQL_GENERAL_V2
      );
      return response?.data || { items: [], total: 0 };
    } catch (exc) {
      ExceptionManager(exc, route, "searchAssetSubtypes");
      return rejectWithValue(exc);
    }
  }
);


manageSearchAssetSubtypes.query = `
    query ($conditions: [AssetSubtypeSearchInput], $sort: [AssetSubtypeSortInput], $limit: Int, $offset: Int) {
        data: searchAssetSubtypes(
            conditions: $conditions
            sort: $sort
            limit: $limit
            offset: $offset
        ) {
          total
          items {
            id
            name
            createdOn
            updatedOn
          }
        }
    }
`;


export { manageSearchAssetSubtypes }

//Slice
const manageAssetSubtypesTabRedux = createSlice({
  name: "manage/assetSubtype",
  initialState: INIT_STATE,
  reducers: {
    reset(state, action) {
      return action.payload ? { ...state, ...action.payload } : INIT_STATE;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(resetALL, () => INIT_STATE);

    //manageSearchKeyFobs
    builder.addCase(manageSearchAssetSubtypes.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(manageSearchAssetSubtypes.fulfilled, (state, action) => {
      state.loading = false;
      state.items = action.payload.items;
      state.total = action.payload.total;
    });
    builder.addCase(manageSearchAssetSubtypes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

// Extract and export the action creators object and the reducer
export const { actions, reducer } = manageAssetSubtypesTabRedux;

// Extract and export each action creator by name
export const { reset } = actions;

// Export the reducer, either as a default or named export
export default reducer;